var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.001C24.8366 32.001 32 24.8375 32 16.001C32 7.16442 24.8366 0.000976562 16 0.000976562C7.16344 0.000976562 0 7.16442 0 16.001C0 24.8375 7.16344 32.001 16 32.001Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 6.26178L29.2173 16.0009L16 25.74L2.78259 16.0009L16 6.26178Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.5662C19.0736 21.5662 21.5652 19.0745 21.5652 16.001C21.5652 12.9274 19.0736 10.4358 16 10.4358C12.9264 10.4358 10.4348 12.9274 10.4348 16.001C10.4348 19.0745 12.9264 21.5662 16 21.5662Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2175 15.6531C12.2497 15.6531 11.3158 15.8003 10.4366 16.0735C10.4756 19.1135 12.9508 21.5662 16.0001 21.5662C17.8856 21.5662 19.5508 20.6276 20.5575 19.1932C18.8352 17.0371 16.1851 15.6531 13.2175 15.6531V15.6531Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4622 17.0672C21.5292 16.722 21.5654 16.3658 21.5654 16.001C21.5654 12.9274 19.0738 10.4358 16.0002 10.4358C13.7069 10.4358 11.7381 11.8234 10.8861 13.8045C11.6392 13.6484 12.419 13.5662 13.2177 13.5662C16.45 13.5662 19.3741 14.9098 21.4622 17.0672V17.0672Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBr);
export default __webpack_public_path__ + "static/media/BR.e60d59c5.svg";
export { ForwardRef as ReactComponent };